<div class="container py-5">
  <div class="row">
    <div *ngIf="(isShowingOnlyFeatured$ | async) else displayAll" class="col-lg-7 col-md-11">
      <h3 class="products-header mb-3">Featured Products</h3>
      <div class="col-lg-6 col-md-12 col-sm-12 text-center mt-4 mb-2 ps-0 d-grid">
        <a routerLink="/products"
           [queryParams]="{view: 'all'}"
           routerLinkActive="active"
           id="displayAll"
           class="btn btn-featured py-3 mt-4">See The Full List Of Products</a>
      </div>
    </div>

    <ng-template #displayAll>
      <div class="col-lg-7 col-md-10">
        <h3 *ngIf="!userIsEmployee()" class="products-header mb-3">Free and Specially Priced Student Licenses</h3>
        <h3 *ngIf="userIsEmployee()" class="products-header mb-3">Free and Specially Priced Software</h3>
      </div>
      <div class="col-12"
           *ngIf="userIsEmployee()">
        <app-product-filter-chooser
          (filterUpdate)="selectNewFilters($event)"></app-product-filter-chooser>
      </div>
    </ng-template>
  </div>

  <div class="row">
    <div class="col-12 col-md-4 pe-5" *ngFor="let product of (productsToDisplay$ | async)">
      <app-product [product]="product" [studentOfferings]="getStudentOfferings(product)"
                   [employeeOfferings]="getEmployeeOfferings(product)"
                   [universityOfferings]="getUniversityOfferings(product)"></app-product>
    </div>
  </div>
  <div id="noProducts" *ngIf="productsToDisplay$ | async | empty">
    No Products
  </div>
</div>
